import { render, staticRenderFns } from "./ProcessesWorks.vue?vue&type=template&id=d50f4976&"
import script from "./ProcessesWorks.vue?vue&type=script&lang=js&"
export * from "./ProcessesWorks.vue?vue&type=script&lang=js&"
import style0 from "./ProcessesWorks.vue?vue&type=style&index=0&id=d50f4976&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports